import type { Components } from '@mui/material/styles';

export default function MUIContainer(): Components['MuiContainer'] {
  return {};
}
